import { Box, Checkbox, RadioGroup, Typography } from "@mui/material";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import styles from "./T5_CancelLine.module.scss";
import { useEffect, useState } from "react";
import envConfig from "../../../config/env.config.json";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { useNavigate } from "react-router-dom";
import {
  cancelLine,
  customerGroup,
  getCC,
  resetCancelState,
  resetGroup,
} from "../../../features/account/accountSlice";
import { ButtonCust, RadioCust } from "../../widgets";
import { RoutingURLs } from "../../../config/RoutingURLs";
// import { updateSvgFillColor } from "../../../utils";
import StepperComponent from "./StepperComponent";

const T1_cancelLine = (props: any) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const {
    cancelLineData,
    leavingReachData,
    terminateLineData,
    cancelLineLoading,
  } = useAppSelector((state: any) => state.account);
  const {
    handleBack,
    Content,
    currentUser,
    handleCancelLine,
    setCancelReason,
    cancelReason,
  } = props;
  const [step, setStep] = useState(0);

  useEffect(() => {
    if (leavingReachData?.status === "SUCCESS") {
      setCancelStep(0);
    }
  }, [leavingReachData]);

  const { getCCDetails } = useAppSelector((state: any) => state?.account || {});
  const currentCard = getCCDetails?.filter(
    (val: any) => val?.isAutoPay || val?.isDefault
  );
  useEffect(() => {
    const banner = document.getElementById("banner_internal_parent");
    const account = document.getElementById("account_parent");
    if (banner) {
      banner.style.display = "none";
    }
    if(account){
      account.style.display = "none";
    }
    dispatch(
      getCC({
        customerId: customerDetails && customerDetails.id,
      })
    );

    return () => {
      if (banner) {
        banner.style.display = "unset";
      }
      if(account){
        account.style.display = "flex";
      }
    };
  }, []);

  const { configKeys } = useAppSelector((state: any) => state?.activation);
  const [isTandCChecked, setIsTandCChecked] = useState(false);
  const [cancelStep, setCancelStep] = useState(1);
  let customerDetails: any = localStorage.getItem("customerDetail");
  customerDetails = JSON.parse(customerDetails);
  useEffect(() => {
    if (leavingReachData?.status === "SUCCESS") {
      setStep(3);
    } else if (cancelLineLoading) {
      setStep(2);
    } else if (cancelStep === 2) {
      setStep(1);
    } else if (cancelStep === 1) {
      setStep(0);
    }
  }, [leavingReachData, cancelStep, cancelLineLoading]);
  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          mb: "10rem",
          // mt: { xs: "2rem", lg: "5rem" },
          background: "var(--light-grey)",
        }}
      >
        {/* Back */}
        {/* <Box
          className={`${styles.heading_container}`}
          sx={{ marginBottom: { xs: "30px", sm: 0 } }}
          onClick={() => {
            if (cancelStep === 1) {
              handleBack("home");
            } else {
              setCancelStep(1);
              setCancelReason(null);
              setIsTandCChecked(false);
            }
          }}
        >
          <ArrowBackIosIcon
            sx={{
              ml: { md: "30px", sm: "25px", xs: "4%" },
              fontSize: { xs: "1em", md: "16px" },
            }}
            className={styles.arrow_icon}
          />

          <Typography
            sx={{
              ml: { md: "55px", sm: "55px", xs: "8%" },

              left: { xs: "10px", sm: "1px" },
              position: "absolute",
              display: {
                xs: "block",
                sm: "block",
                textDecoration: "underline",
                fontFamily: "var(--font_family_Bold)",
                color: "var(--text_color) !important",
              },
            }}
          >
            {Content?.back}
          </Typography>
        </Box> */}
        <Box sx={{ width: "100%", background: "#FFFFFF" }}>
          <StepperComponent activeStep={step} steps={Content?.steps} />
        </Box>
        {cancelLineLoading ? (
          <>
            <Box className={styles.bodyContainer}>
              <Box
                component="img"
                src={Content?.ld_ic?.data?.attributes?.url}
                alt={Content?.ld_ic?.data?.attributes?.alternativeText}
                width={"100px"}
                height={"85px"}
              ></Box>
              <Typography
                component="h5"
                sx={{
                  fontSize: { xs: "20px", sm: "24px" },
                  color: "#313131",
                  lineHeight: { xs: "32px", sm: "36px" },
                  fontFamily: "var(--font_family_Bold) !important",
                  textAlign: "center",
                  width: { xs: "100%", sm: "90%" },
                  marginTop: "20px",
                  marginBottom: "10px",
                }}
                dangerouslySetInnerHTML={{
                  __html: Content?.ld_tit,
                }}
              ></Typography>
              <Typography
                component="h5"
                sx={{
                  fontSize: { xs: "14px", sm: "16px" },
                  color: "#313131",
                  lineHeight: { xs: "22px", sm: "24px" },
                  fontFamily: "var(--font_family_Regular) !important",
                  textAlign: "center",
                  marginTop: "10px",
                  marginBottom: "20px",
                }}
                dangerouslySetInnerHTML={{
                  __html: Content?.ld_des,
                }}
              ></Typography>

              <Box
                display={"flex"}
                sx={{
                  justifyContent: "space-evenly",
                  alignItems: "center",
                  flexDirection: { xs: "column", sm: "row" },
                  gap: { xs: "20px", sm: "35px" },
                  width: "100%",
                }}
                my={3}
              >
                <ButtonCust
                  variantType={envConfig.PRIMARY_BUTTON_TYPE}
                  onClick={() => {
                    dispatch(resetCancelState());
                    dispatch(resetGroup());
                    dispatch(customerGroup({ groupId: currentUser?.groupId }));
                    handleBack("home");
                  }}
                  disabled={false}
                  sx={{
                    fontSize: "16px !important",
                    height: "45px !important",
                    color: "#FFFFFF !important",
                    width: { xs: "100%", sm: "250px !important" },
                    background: "var(--primary_color) !important",
                    "&:hover": {
                      backgroundColor: "var(--primary_color) !important",
                      opacity: "1 !important",
                    },
                  }}
                >
                  {Content?.go_acc}
                </ButtonCust>
              </Box>
            </Box>
          </>
        ) : null}

        {!cancelLineLoading &&
        cancelStep === 1 &&
        cancelLineData === null &&
        leavingReachData === null &&
        terminateLineData === null ? (
          <>
            {/* <Typography className={styles.title}>
              {Content?.step1_title}
            </Typography>
            <Typography className={styles.step}>{Content?.step1}</Typography> */}
            <Box className={styles.bodyContainer}>
              <Typography
                component="h5"
                sx={{
                  fontSize: { xs: "20px", sm: "24px" },
                  color: "var(--black)",
                  lineHeight: { xs: "32px", sm: "36px" },
                  fontFamily: "var(--font_family_Bold) !important",
                  textAlign: "center",
                  width: "90%",
                  marginTop: "20px",
                  marginBottom: "10px",
                }}
                dangerouslySetInnerHTML={{
                  __html: Content?.sp1_tit,
                }}
              ></Typography>
              <Box
                display={"flex"}
                sx={{
                  justifyContent: "start",
                  alignItems: { xs: "self-start", sm: "self-start" },
                  "& svg": {
                      color: "#313131",
                      opacity: "0.2 !important",
                    },
                    "& .Mui-checked": {
                      "& svg": {
                        color: "var(--primary_color) !important",
                        opacity: "1 !important",
                      },
                    },
                }}
                my={2}
              >
                <Checkbox
                  value={isTandCChecked}
                  sx={{
                    color: "var(--primary_color) !important",
                    padding: "3px 10px 0px 0px",
                    marginTop: 0,
                  }}
                  onChange={() => {
                    setIsTandCChecked((prev) => !prev);
                  }}
                />
                <Box>
                  <Typography
                    component="p"
                    sx={{
                      fontSize: { xs: "16px", sm: "18px" },
                      color: "#56585E",
                      fontFamily: "var(--font_family_Semibold) !important",
                      lineHeight: { xs: "24px", sm: "28px" },
                    }}
                    dangerouslySetInnerHTML={{
                      __html: Content?.cb_tit,
                    }}
                  ></Typography>
                  <Typography
                    component="p"
                    sx={{
                      fontSize: { xs: "14px", sm: "16px" },
                      color: "var(--text_color_12)",
                      fontFamily: "var(--font_family_Regular) !important",
                      lineHeight: { xs: "24px", sm: "28px" },
                      marginTop: "10px",
                    }}
                    dangerouslySetInnerHTML={{
                      __html: (currentUser?.isPrimary
                        ? Content?.cb_des
                        : Content?.cb_des1
                      )
                        ?.replaceAll(
                          "{{name}}",
                          `${currentUser?.firstName ?? ''} ${currentUser?.lastName ?? ''}`
                        ),
                    }}
                  ></Typography>
                </Box>
              </Box>
              <Box
                display={"flex"}
                sx={{
                  justifyContent: "space-evenly",
                  alignItems: "center",
                  flexDirection: { xs: "column", sm: "row" },
                  gap: { xs: "20px", sm: "35px" },
                  width: "100%",
                }}
                my={3}
              >
                <ButtonCust
                  variantType={envConfig.PRIMARY_BUTTON_TYPE}
                  onClick={() => {
                    handleBack("home");
                  }}
                  disabled={false}
                  sx={{
                    fontSize: "16px !important",
                    height: "45px !important",
                    background: "var(--white) !important",
                    color: "var(--primary_color) !important",
                    width: { xs: "100%", sm: "250px !important" },
                  }}
                >
                  {Content?.dn_cl}
                </ButtonCust>
                <ButtonCust
                  variantType={envConfig.PRIMARY_BUTTON_TYPE}
                  onClick={() => {
                    setCancelStep(2);
                  }}
                  disabled={!isTandCChecked}
                  sx={{
                    fontSize: "16px !important",
                    height: "45px !important",
                    color: "#FFFFFF !important",
                    width: { xs: "100%", sm: "250px !important" },
                    background: "var(--primary_color) !important",
                    opacity: !isTandCChecked ? "0.7" : "1",
                    "&:hover": {
                      // backgroundColor: "inherit !important",
                      // border: "1px solid var(--button_hover_color) !important",
                      backgroundColor: "var(--primary_color) !important",
                      opacity: !isTandCChecked
                        ? "0.7 !important"
                        : "1 !important",
                    },
                  }}
                >
                  {Content?.cn_sr}
                </ButtonCust>
              </Box>
            </Box>
            <Box
              className={styles.bodyContainer_2}
              sx={{
                padding: "10px 20px !important",
                marginTop: "40px !important",
              }}
            >
              <Box
                display={"flex"}
                sx={{
                  justifyContent: "center",
                  alignItems: "center",
                  // gap: "10px",
                  flexDirection: { xs: "column", sm: "row" },
                }}
              >
                <Box
                  component="img"
                  alt={Content?.ct_img?.data?.attributes?.alternativeText}
                  src={Content?.ct_img?.data?.attributes?.url || ""}
                  width="26px"
                  height="26px"
                  sx={{
                    marginRight: "5px",
                    minWidth: "35px",
                    display: "flex",
                    justifyContent: "center",
                  }}
                ></Box>
                <Typography
                  component="span"
                  sx={{
                    fontSize: "14px",
                    color: "var(--black)",
                    fontFamily: "var(--font_family_Medium) !important",
                    textAlign: { xs: "center", sm: "left" },
                    a: {
                      color: "var(--black)",
                      fontFamily: "var(--font_family_Bold) !important",
                      cursor: "pointer",
                      textDecoration: "none",
                    },
                  }}
                  dangerouslySetInnerHTML={{
                    __html: (Content?.ct_us)?.replace(
                      "url",
                      "https://www.maxxmobile.net/contact-us"
                    ),
                  }}
                ></Typography>
              </Box>
            </Box>
          </>
        ) : null}
        {!cancelLineLoading &&
        cancelStep === 2 &&
        cancelLineData === null &&
        leavingReachData === null &&
        terminateLineData === null ? (
          <>
            {/* <Typography className={styles.title}>
              {Content?.step2_title}
            </Typography>
            <Typography className={styles.step}>{Content?.step2}</Typography> */}
            <Box
              className={styles.bodyContainer}
              // sx={{ padding: "20px 30px !important", width: "43% !important" }}
            >
              <Typography
                component="h5"
                sx={{
                  fontSize: { xs: "20px", sm: "24px" },
                  color: "var(--black)",
                  lineHeight: { xs: "32px", sm: "36px" },
                  fontFamily: "var(--font_family_Bold) !important",
                  textAlign: "center",
                  width: { xs: "100%", sm: "100%" },
                  marginTop: "20px",
                  marginBottom: "10px",
                }}
                dangerouslySetInnerHTML={{
                  __html: Content?.sp2_tit,
                }}
              ></Typography>
              <Typography className={styles.step}>{Content?.sl_re}</Typography>
              <RadioGroup
                value={cancelReason}
                onChange={(e: any) => setCancelReason(e.target.value)}
                sx={{
                  "& .css-j204z7-MuiFormControlLabel-root .MuiFormControlLabel-label":
                    {
                      color: "var(--text_color)",
                      fontSize: "14px",
                      fontFamily: "var(--font_family_Medium)",
                    },
                  display: "flex",
                  flexDirection: { xs: "column", sm: "row" },
                  justifyContent: "space-between",
                  width: "100%",
                  "& svg": {
                    color: "#313131",
                    opacity: "0.2 !important",
                  },
                  "& .Mui-checked": {
                    "& svg": {
                      color: "var(--primary_color) !important",
                      opacity: "1 !important",
                    },
                  },
                }}
                row
              >
                <Box>
                  {configKeys?.LINE_CANCEL_REASONS?.slice(0, 3)?.map(
                    (reason: any, index: any) => {
                      return (
                        <RadioCust
                          value={reason}
                          label={reason}
                          key={reason}
                          sx={{
                            "& .css-j204z7-MuiFormControlLabel-root": {
                              "& .css-vqmohf-MuiButtonBase-root-MuiRadio-root":
                                {
                                  color: "var(--primary_color) !important",
                                },
                            },
                          }}
                        />
                      );
                    }
                  )}
                </Box>
                <Box
                  sx={{
                    "& label": {
                      marginRight: "-25px !important",
                    },
                  }}
                >
                  {configKeys?.LINE_CANCEL_REASONS?.slice(3, 6)?.map(
                    (reason: any, index: any) => {
                      return (
                        <RadioCust
                          value={reason}
                          label={reason}
                          key={reason}
                          sx={{
                            color: "#56585E !important",
                            fontSize: "14px !important",
                            fontFamily: "var(--font_family_Medium)",
                            "& .MuiFormControlLabel-root": {
                              marginRight: "0px !important",
                            },
                          }}
                        />
                      );
                    }
                  )}
                </Box>
              </RadioGroup>
              <Box
                display={"flex"}
                sx={{
                  justifyContent: "space-evenly",
                  alignItems: "center",
                  flexDirection: { xs: "column", sm: "row" },
                  gap: { xs: "20px", sm: "35px" },
                  width: "100%",
                }}
                my={3}
              >
                <ButtonCust
                  variantType={envConfig.PRIMARY_BUTTON_TYPE}
                  onClick={() => {
                    handleBack("home");
                  }}
                  disabled={false}
                  sx={{
                    fontSize: "16px !important",
                    height: "45px !important",
                    background: "var(--white) !important",
                    color: "var(--primary_color) !important",
                    width: { xs: "100%", sm: "250px !important" },
                  }}
                >
                  {Content?.dn_cl}
                </ButtonCust>
                <ButtonCust
                  variantType={envConfig.PRIMARY_BUTTON_TYPE}
                  onClick={() => {
                    handleCancelLine();
                  }}
                  loading={cancelLineLoading}
                  disabled={cancelReason === null}
                  sx={{
                    fontSize: "16px !important",
                    height: "45px !important",
                    color: "#FFFFFF !important",
                    width: { xs: "100%", sm: "250px !important" },
                    background: "var(--primary_color) !important",
                    opacity: cancelReason === null ? "0.7" : "1",
                    "&:hover": {
                      // backgroundColor: "inherit !important",
                      // border: "1px solid var(--button_hover_color) !important",
                      backgroundColor: "var(--primary_color) !important",
                      opacity:
                        cancelReason === null
                          ? "0.7 !important"
                          : "1 !important",
                    },
                  }}
                >
                  {Content?.cl}
                </ButtonCust>
              </Box>
            </Box>
          </>
        ) : null}
        {/* {cancelLineLoading ? (
          <>
            <Typography className={styles.title}>
              {"Cancelation in progress..."}
            </Typography>
            <Typography className={styles.step}>
              {"This may take a few minutes."}
            </Typography>
            <ButtonCust
              variantType={envConfig.PRIMARY_BUTTON_TYPE}
              onClick={() => {
                handleBack("home");
              }}
              sx={{
                width: "200px",
                height: "50px !important",
                "&:hover": {
                  backgroundColor: "var(--button_hover_color) !important",
                  border: "1px solid var(--button_hover_color) !important",
                },
              }}
            >
              {"Continue to Home"}
            </ButtonCust>
          </>
        ) : null} */}
        {!cancelLineLoading && leavingReachData?.status === "SUCCESS" ? (
          <>
            <Box className={styles.bodyContainer}>
              <Box
                component="img"
                src={Content?.tick1?.data?.attributes?.url}
                alt={Content?.tick1?.data?.attributes?.atlTxt}
                height="50px"
                width="50px"
              ></Box>
              <Typography
                component="h5"
                sx={{
                  fontSize: { xs: "20px", sm: "24px" },
                  color: "#313131",
                  lineHeight: { xs: "32px", sm: "36px" },
                  fontFamily: "var(--font_family_Bold) !important",
                  textAlign: "center",
                  width: { xs: "100%", sm: "90%" },
                  marginTop: "20px",
                  marginBottom: "5px",
                }}
                dangerouslySetInnerHTML={{
                  __html: Content?.su_tit,
                }}
              ></Typography>
              <Typography
                component="h5"
                sx={{
                  fontSize: { xs: "14px", sm: "16px" },
                  color: "#313131",
                  lineHeight: { xs: "22px", sm: "24px" },
                  fontFamily: "var(--font_family_Regular) !important",
                  textAlign: "center",
                  marginTop: "10px",
                  marginBottom: "20px",
                  fontWeight: "400 !important",
                  "& b": {
                    fontFamily: "var(--font_family_Medium) !important",
                    fontWeight: "500 !important",
                  },
                }}
                dangerouslySetInnerHTML={{
                  __html: (currentUser?.isPrimary
                    ? Content?.su_des1
                    : Content?.su_des2
                  )
                    ?.replaceAll(
                      "{{name}}",
                      `${currentUser?.firstName} ${currentUser?.lastName}`
                    )
                    ?.replaceAll("{{card}}", currentCard?.[0]?.ccNumberMask),
                }}
              ></Typography>

              <Box
                display={"flex"}
                sx={{
                  justifyContent: "space-evenly",
                  alignItems: "center",
                  flexDirection: { xs: "column", sm: "row" },
                  gap: { xs: "20px", sm: "35px" },
                  width: "100%",
                }}
                my={3}
              >
                <ButtonCust
                  variantType={envConfig.PRIMARY_BUTTON_TYPE}
                  onClick={() => {
                    dispatch(resetCancelState());
                    dispatch(resetGroup());
                    dispatch(customerGroup({ groupId: currentUser?.groupId }));
                    handleBack("home");
                  }}
                  disabled={false}
                  sx={{
                    fontSize: "16px !important",
                    height: "45px !important",
                    color: "#FFFFFF !important",
                    width: { xs: "100%", sm: "250px !important" },
                    background: "var(--primary_color) !important",
                    "&:hover": {
                      backgroundColor: "var(--primary_color) !important",
                      opacity: "1 !important",
                    },
                  }}
                >
                  {Content?.go_acc}
                </ButtonCust>
              </Box>
            </Box>
          </>
        ) : null}
        {/* {cancelLineData?.status === "SUCCESS" ||
        terminateLineData?.status === "SUCCESS" ? (
          <>
            <Box
              component="img"
              src={Content?.tick?.data?.attributes?.url}
              alt={Content?.tick?.data?.attributes?.atlTxt}
              height="50px"
              width="50px"
              mb="30px"
            ></Box>

            <Typography className={styles.title}>
              {Content?.cancelled_success}
            </Typography>
            <Box
              className={styles.bodyContainer}
              sx={{ textAlign: "center", marginTop: "30px" }}
            >
              <Typography className={styles.step}>
                {Content?.line_cancelled.replace(
                  "customer",
                  currentUser?.firstName
                )}
              </Typography>
              <Typography className={styles.step}>
                {Content?.refund_info}
              </Typography>

              <ButtonCust
                variantType={envConfig.PRIMARY_BUTTON_TYPE}
                onClick={() => {
                  navigate(RoutingURLs.home);
                  dispatch(resetCancelState());
                  dispatch(customerGroup({ groupId: currentUser?.groupId }));
                }}
                sx={{
                  width: "200px",
                  height: "50px !important",
                  "&:hover": {
                    backgroundColor: "var(--button_hover_color) !important",
                    border: "1px solid var(--button_hover_color) !important",
                  },
                }}
              >
                {Content?.continue_to_home}
              </ButtonCust>
            </Box>
          </>
        ) : null} */}
      </Box>
    </Box>
  );
};
export default T1_cancelLine;
